/**
 * Old handling.
 */
function homepage() {

    POP = window.POP || {};
    POP.params = POP.params || {};

    // force redirect to non-IE compatible early
    if (!$('html').hasClass('compatible')) {
        window.location.href = '/ugh/IE/really';
        return;
    }

    // Setting Actions per version of homepage
    if ( $('.homepage-pricing-bottom').length > 0 ){
        $('.home-title a.btn-primary, .features-cta-block .cta-button a').on('click', function(){
            POP.scrollTo('.price-tables', false, true);
        });
    } else {
        // Setting click handler as named function to allow unbinding
         function tabNavigation(event){
             event.preventDefault();
             var $this = $(this);
             $("#tab-list li").removeClass("active");
             
             if( event.target.nodeName == 'DIV'){
                 event.stopPropagation();
                 $this.parents('li').addClass("active");
                 $this.find('a').tab('show');
             } else if( event.target.nodeName == 'A'){
                 event.stopPropagation();
                 $this.parents('li').addClass("active");    
                 $this.tab('show');
             } else if( event.target.nodeName == 'LI'){
                 $this.addClass("active");    
                 $this.find('a').tab('show');
             }
         }

         // Setting Tab Pane Switching
         $(document).on('click', '#tab-list a, #tab-list li > div, #tab-list li', tabNavigation );

    }

    

    // set raw cookies
    $.cookie.raw = true;

    
} // Close of homepage function
